var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM7.29 14.29L3.7 10.7a.996.996 0 111.41-1.41L8 12.17l6.88-6.88a.996.996 0 111.41 1.41L8.7 14.29a.996.996 0 01-1.41 0z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48cGF0aCBkPSJNMTAsMCBDNC40OCwwIDAsNC40OCAwLDEwIEMwLDE1LjUyIDQuNDgsMjAgMTAsMjAgQzE1LjUyLDIwIDIwLDE1LjUyIDIwLDEwIEMyMCw0LjQ4IDE1LjUyLDAgMTAsMCBaIE03LjI5LDE0LjI5IEwzLjcsMTAuNyBDMy4zMSwxMC4zMSAzLjMxLDkuNjggMy43LDkuMjkgQzQuMDksOC45IDQuNzIsOC45IDUuMTEsOS4yOSBMOCwxMi4xNyBMMTQuODgsNS4yOSBDMTUuMjcsNC45IDE1LjksNC45IDE2LjI5LDUuMjkgQzE2LjY4LDUuNjggMTYuNjgsNi4zMSAxNi4yOSw2LjcgTDguNywxNC4yOSBDOC4zMiwxNC42OCA3LjY4LDE0LjY4IDcuMjksMTQuMjkgWiIvPjwvc3ZnPg==";
export { SvgCheckMark as ReactComponent };